import React from 'react';
import {Link, NavLink} from 'react-router-dom';

const NavbarCard = ({company, onClickToLogout}) => {
  const companyLogo = company
    .split(' ')
    .map((word) => word[0])
    .join()
    .replace(',', '');

  return (
    <div className="navbar-card-container">
      <div className="navbar-card-logo-container">
        <p className="navbar-card-logo">{companyLogo}</p>
      </div>
      <div className="navbar-card-text">
        <NavLink
          exact
          to="/"
          activeStyle={{
            fontWeight: 'bold',
            textDecoration: 'underline',
          }}
          className="navbar-card-company"
        >
          {company}
        </NavLink>
        <Link className="navbar-card-logout" to="/connexion" onClick={onClickToLogout}>
          Se déconnecter
        </Link>
      </div>
    </div>
  );
};

export default NavbarCard;
